import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCMAPresentationApi } from "../../apis/comps/presentation/api-factories";
import { buildGetCmaPresentationEditQueryKey } from "./useGetCmaPresentationEdit";
import { CMA_SCOPE_KEY } from "./cma.key";

export const useFetchAllSectionsData = () => {
  const api = getCMAPresentationApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (presentationId: string) => {
      return api.cMAPresentationControllerFetchAllSectionsData({
        id: presentationId,
      });
    },
    onSuccess: (_, presentationId) => {
      queryClient.invalidateQueries({
        queryKey: buildGetCmaPresentationEditQueryKey(presentationId),
      });
    },
    mutationKey: [CMA_SCOPE_KEY, "fetch-all-sections-data"],
  });
};
